import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-common-layout',
  styleUrls: ['./common-layout.components.scss'],
  templateUrl: './common-layout.component.html',
})
export class CommonLayoutComponent implements OnInit {

  showFiller = false;
  showSidename:boolean = false;
  currentRout:any;
  userDetails:any = localStorage.getItem("currentUser")

  constructor(private route: Router) { }

  ngOnInit(): void {
    if(this.route.url == '/club_dashboard'){
      this.showSidename = false;
    }else{
      this.showSidename = true
    }
  }


}
